import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "fury-view-history",
  templateUrl: "./view-history.component.html",
  styleUrls: ["./view-history.component.scss"],
})
export class ViewHistoryComponent {
  constructor(
    public dialogRef: MatDialogRef<ViewHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[],
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
